import { defineComponent as r, createBlock as a, openBlock as l, unref as p, mergeProps as v, withCtx as c, createElementVNode as t } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const s = /* @__PURE__ */ r({
  name: "IconAvatar",
  __name: "IconAvatar",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (i, e) => (l(), a(p(d), v(n, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        t("path", {
          "fill-rule": "evenodd",
          d: "M12 3.25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5M8.75 8a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0",
          "clip-rule": "evenodd"
        }, null, -1),
        t("path", { d: "M8 14.25A4.75 4.75 0 0 0 3.25 19v1a.75.75 0 0 0 1.5 0v-1A3.25 3.25 0 0 1 8 15.75h8A3.25 3.25 0 0 1 19.25 19v1a.75.75 0 0 0 1.5 0v-1A4.75 4.75 0 0 0 16 14.25H8" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
